import { useEffect, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

declare global {
  interface Window {
    flutterBridge: {
      canGoBack: () => boolean;
      getCurrentRoute: () => string;
      goBack: () => void;
      isWebView: () => boolean;
    };
  }
}

// 뒤로가기 불가능한 페이지들 (히스토리 시작점)
const NO_BACK_ROUTES = ['/login', '/main', '/main/home'];

export const useFlutterBridge = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isWebView = useCallback(() => {
    const ua = navigator.userAgent.toLowerCase();
    return ua.includes('wv') || ua.includes('webview');
  }, []);

  const canGoBack = useCallback(() => {
    // 히스토리 시작점 페이지면 뒤로가기 불가
    if (NO_BACK_ROUTES.includes(location.pathname)) {
      return false;
    }
    // 브라우저 히스토리 길이로 판단
    return window.history.length > 1;
  }, [location.pathname]);

  const getCurrentRoute = useCallback(() => {
    return location.pathname;
  }, [location.pathname]);

  const goBack = useCallback(() => {
    // 뒤로가기 불가능한 페이지면 무시
    if (NO_BACK_ROUTES.includes(location.pathname)) {
      return;
    }
    navigate(-1);
  }, [navigate, location.pathname]);

  // 브릿지 등록
  useEffect(() => {
    window.flutterBridge = {
      canGoBack,
      getCurrentRoute,
      goBack,
      isWebView,
    };

    // Flutter에 브릿지 준비 완료 알림
    window.dispatchEvent(new CustomEvent('flutterBridgeReady'));

    console.log('[FlutterBridge] 브릿지 등록 완료, 현재 경로:', location.pathname);
  }, [canGoBack, getCurrentRoute, goBack, isWebView, location.pathname]);

  return { canGoBack, getCurrentRoute, goBack, isWebView };
};
